import React from 'react'

const Header = () => {
  return (
    <header>
            <div>
                <img 
                src="https://github.com/danielrosadasilva.png" 
                alt="Foto de Daniel Rosa um programador" />
            </div>
    </header>
  )
}

export default Header